import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Popover from 'material-ui/Popover';
import { withTranslation } from 'react-i18next';

import SlateViewsList from './SlateViewsList';
import { slateViewsTypes } from 'config/constants';
import './style.css';
import 'css/selector-dropdown.css';

class SlateViewsDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listViews: props.listViews,
      mapViews: props.mapViews,
      searchQuery: '',
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.open !== this.props.open && this.props.open) {
      this.setState({
        listViews: this.props.listViews,
        mapViews: this.props.mapViews,
        searchQuery: '',
      });
    }
  }

  handleSearch = (event) => {
    var query = event.target.value;
    var listViews = this.props.listViews;
    var mapViews = this.props.mapViews;

    this.setState({ searchQuery: query });

    if (query.length === 0) {
      this.setState({
        listViews: listViews,
        mapViews: mapViews,
      });
      return;
    }

    var lowerQuery = query.toLowerCase();
    var filteredList = listViews.filter(function(item) {
      return item.name.toLowerCase().indexOf(lowerQuery) !== -1;
    });
    var filteredMap = mapViews.filter(function(item) {
      return item.name.toLowerCase().indexOf(lowerQuery) !== -1;
    });

    this.setState({
      listViews: filteredList,
      mapViews: filteredMap,
    });
  };

  handleViewClick = (uuid) => {
    this.props.onSlateViewClick(uuid);
    this.props.onClose();
  };

  handleCreateClick = () => {
    this.props.onClose();
    if (this.props.onCreateViewClick) {
      this.props.onCreateViewClick();
    }
  };

  render() {
    var _this = this;
    var props = this.props;
    var state = this.state;
    var open = props.open;
    var anchorEl = props.anchorEl;
    var onClose = props.onClose;
    var t = props.t;
    var listViews = state.listViews;
    var mapViews = state.mapViews;
    var searchQuery = state.searchQuery;

    return (
      <Popover
        open={open}
        anchorEl={anchorEl}
        onRequestClose={onClose}
        anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
        targetOrigin={{ horizontal: 'left', vertical: 'top' }}
        className="selector-dropdown-popover"
        zDepth={0}
        style={{
          marginTop: 8,
          background: 'transparent',
          boxShadow: 'none',
          overflow: 'visible',
          borderRadius: 12,
        }}
      >
        <div className="selector-dropdown">
          <div className="selector-dropdown-header">
            <div className="selector-dropdown-search">
              <span className="material-symbols-outlined selector-dropdown-search-icon">search</span>
              <input
                className="selector-dropdown-search-input"
                type="text"
                placeholder={t('slateViews:searchViews')}
                value={searchQuery}
                onChange={_this.handleSearch}
              />
            </div>
            <button
              className="selector-create-btn"
              onClick={_this.handleCreateClick}
            >
              <span className="material-symbols-outlined" style={{ fontSize: 14 }}>add</span>
              {t('slateViews:createView')}
            </button>
          </div>

          <div className="selector-dropdown-content">
            {listViews.length > 0 && (
              <SlateViewsList
                views={listViews}
                type={slateViewsTypes.LIST}
                onSlateViewClick={_this.handleViewClick}
                compact
              />
            )}
            {mapViews.length > 0 && (
              <SlateViewsList
                views={mapViews}
                type={slateViewsTypes.MAP}
                onSlateViewClick={_this.handleViewClick}
                compact
              />
            )}
            {listViews.length === 0 && mapViews.length === 0 && (
              <div className="selector-dropdown-empty">
                No views found
              </div>
            )}
          </div>
        </div>
      </Popover>
    );
  }
}

SlateViewsDropdown.propTypes = {
  open: PropTypes.bool.isRequired,
  anchorEl: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  listViews: PropTypes.array.isRequired,
  mapViews: PropTypes.array.isRequired,
  onSlateViewClick: PropTypes.func.isRequired,
  onCreateViewClick: PropTypes.func,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(SlateViewsDropdown);
